var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassiveSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "group-24px_4_",
    "data-name": "group-24px (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2330",
    "data-name": "Trac\\xE9 2330",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1776",
    "data-name": "Groupe 1776",
    transform: "translate(20905.262 12968)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_210",
    "data-name": "Ellipse 210",
    cx: 2.385,
    cy: 2.385,
    r: 2.385,
    transform: "translate(-20899.002 -12952.771)",
    fill: "rgba(0,0,0,0.6)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_211",
    "data-name": "Ellipse 211",
    cx: 2.385,
    cy: 2.385,
    r: 2.385,
    transform: "translate(-20892.289 -12964)",
    fill: "rgba(0,0,0,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_324",
    "data-name": "Trac\\xE9 324",
    d: "M106.72,129.26a4.77,4.77,0,0,0,4.77,4.77v-9.539A4.77,4.77,0,0,0,106.72,129.26Z",
    transform: "translate(-21005.723 -13088.49)",
    fill: "rgba(0,0,0,0.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_325",
    "data-name": "Trac\\xE9 325",
    d: "M125.886,143.117a4.769,4.769,0,0,0-4.769-4.77v9.54A4.769,4.769,0,0,0,125.886,143.117Z",
    transform: "translate(-21013.406 -13095.887)",
    fill: "rgba(0,0,0,0.6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassiveSymbol);
export default __webpack_public_path__ + "static/media/passiveSymbol.1e3f8983.svg";
export { ForwardRef as ReactComponent };